module.exports = __webpack_public_path__ + "static/navco-0e50ca98077d93de3724469bf5242826.png";